module.exports = __webpack_public_path__ + "static/media/thia.4938aa2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/thia.jpg
// module id = 721
// module chunks = 0